<template>
  <a-modal
    ref="createModal"
    title="新建"
    :width="900"
    :visible="visible"
    :maskClosable="false"
    @cancel="close"
    @ok="confirmValidate"
    :confirmLoading="confirmLoading"
  >
    <a-form-model ref="ruleForm" :model="commitdata" :rules="rules" layout="inline" class="full-width" :labelCol="{ style: { width: '65px' } }">
      <a-row>
        <a-col :md="8" :sm="24">
          <a-form-model-item label="">
            <a-radio-group name="radioGroup" @change="onRGChange" v-model="inputType" :default-value="1">
              <a-radio :value="1">
                已有期间
              </a-radio>
              <a-radio :value="2">
                新建期间
              </a-radio>
            </a-radio-group>
          </a-form-model-item>
        </a-col>

        <a-col :md="8" :sm="24">
          <a-form-model-item label="期间" prop="forecastMonthTem">
            <!-- <global-select sopDfcBasicDataId
              @change="handleNameChange"
              v-if="inputType==1"
              :value.sync="commitdata.forecastMonthTem"
              selectType="select"
              requestApi="/scp/salesForecast/forecastNamePullDown"
              :selectItem="{ value: 'realValue', label: 'label' }"
            /> -->
            <global-select
              :focusGet="true"
              v-if="inputType==1"
              @change="handlerRangPicker"
              :value.sync="commitdata.forecastMonthHistoryTem"
              selectType="select"
              requestApi="/scp/scpSopBasicData/monthList"
              :selectItem="{ value: 'selectedValue', label: 'selectedValue' }"
            />
            <a-range-picker
              v-else
              class="rp-width"
              :placeholder="['开始日期', '结束日期']"
              valueFormat="YYYYMM"
              format="YYYY-MM"
              :value="commitdata.forecastMonthTem"
              :mode="mode"
              @panelChange="handlePanelChange"
            />
          </a-form-model-item>
        </a-col>
        <a-col :md="24" :sm="24">
          <a-button @click="addLine()" type="primary">新增行</a-button>
        </a-col>
      </a-row>
    </a-form-model>
    <!-- <div class="table-page-operator-wrapper">
      <a-button @click="addLine()" type="primary">新增行</a-button>
    </div> -->
    <a-table
      ref="modalTable"
      :columns="columns"
      :data-source="typeList"
      :pagination="false"
      row-key="indexId"
    >
      <!-- 来源单位 -->
      <span slot="versionCodeTitle">
        <i class="toRequired">*</i>版本
      </span>
      <template slot="indexNum" slot-scope="text, record">
        <span>{{ record }}</span>
      </template>
      <template slot="versionCode" slot-scope="text, record">
        <a-input disabled="true" v-model="record.versionCode" ></a-input>
      </template>
      <!-- 折换 -->
      <span slot="versionDescriptionTitle">
        <i class="toRequired">*</i>说明
      </span>
      <template slot="versionDescription" slot-scope="text, record">
        <a-input v-model="record.description" ></a-input>
      </template>
      <span slot="operation" slot-scope="text, record">
        <a v-if="!record.id" @click="handleDelete(typeList, record)">删除</a>
      </span>
    </a-table>
  </a-modal>
</template>

<script>
import { genType } from '@/api/system/codeconfig'
import { newScpSopBasicData, listScpSopBasicData } from '@/api/scp/general-parameter-settings/supplier-capacity.js'

import moment from 'moment';
// 表单字段
export default {
  props: {
    uomClassOptions: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
            // 表单校验
       rules: {
        forecastName: [
          { required: true, message: '预测名称不能为空', trigger: 'change' }
        ],
        forecastMonthTem: [
          { required: true, message: '选择期间不能为空', trigger: 'change' }
        ]
      },
      queryParams: {
        // 预测名称
        forecastName: undefined,
        startMonth: ''
      },
      commitdata: {
        forecastMonthHistoryTem: '',
        type: 'Y', // Y新增 N是已有
        forecastName: '', // 预测名称
        forecastMonthStart: '', // 预测起始月
        forecastMonthEnd: '', // 预测起始月
        forecastMonthTem: [], // 临时时间
        dtoList: [] // 列表数据
      },
      inputType: 2,
      mode: ['month', 'month'],
      // 状态数据字典
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 当前控件配置:
      confirmLoading: false,
      visible: false,
      columns: [
        // {
        //    title: '序号',
        //    width: 80,
        //    dataIndex: 'indexId'
        // },
        {
          // title: '来源单位',
          width: 150,
          dataIndex: 'versionCode',
          scopedSlots: { customRender: 'versionCode', title: "versionCodeTitle" }
        },
        {
          // title: '说明',
          width: 200,
          dataIndex: 'description',
          scopedSlots: { customRender: 'versionDescription', title: "versionDescriptionTitle" }
        },
        {
          title: '创建人',
          width: 150,
          dataIndex: 'createName'
        },
        {
           title: '创建时间',
           width: 150,
          dataIndex: 'createTime'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' }
        }
      ],
      typeList: [],
      unitOfMeasureList: []
    }
  },
  created () {},
  methods: {
    getHistory (params) {
      listScpSopBasicData(params).then(res => {
          if (res.code === 200) {
            this.typeList = res.rows
          }
        })
      },
    onRGChange (val) {
      const selectType = val.target.value
        this.commitdata.forecastMonthStart = undefined
      this.commitdata.forecastMonthEnd = undefined
      this.commitdata.forecastMonthHistoryTem = undefined
      this.commitdata.forecastMonthTem = []
      this.typeList = []
      if (selectType === 2) {}
    },
    handlerRangPicker (val, selectList) {
        const [startStr, endStr] = val.split('-');
        this.commitdata.forecastMonthStart = startStr;
        this.commitdata.forecastMonthEnd = endStr;
        this.commitdata.forecastMonthTem = [moment(startStr, 'YYYYMM'), moment(endStr, 'YYYYMM')]
        this.getHistory({ monthStart: startStr, monthEnd: endStr })
     },
    handlePanelChange (value, mode) {
      const yearMonth1 = value[0].format('YYYYMM')
      let yearMonth2 = value[1].format('YYYYMM')
      if (this.yearMonthTem !== yearMonth1) {
        const yearAfter5MonthMoment = moment(yearMonth1, 'YYYYMM').add(4, 'months');

        const yearAfter5Month = yearAfter5MonthMoment.format('YYYYMM');
        yearMonth2 = yearAfter5Month
        value[1] = yearAfter5MonthMoment
      }
      this.commitdata.forecastMonthStart = yearMonth1
      this.commitdata.forecastMonthEnd = yearMonth2
      this.commitdata.forecastMonthTem = value
      this.yearMonthTem = yearMonth1
    },
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    handleDelete (arr, record) {
      arr.forEach((item, index) => {
        if (item.indexId === record.indexId) {
          arr.splice(index, 1);
        }
      });
    },
    show () {
      // this.addLine()
      this.visible = true
    },
    addLine () {
      const genParams = {
        codeName: '供应商产能版本'
      }
      genType(genParams).then(response => {
      if (response.code === 200) {
          const arr = JSON.parse(JSON.stringify(this.typeList))
          const indexId = arr.length > 0 ? arr[arr.length - 1].indexId : 0
          const obj = {
            versionCode: response.data, // 版本
            description: '', // 版本说明
            indexId: Number(indexId) + 1
          }
          arr.push(obj)
          this.typeList = arr
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 关闭模态框
    close () {
      this.reset()
      this.visible = false
    },
    confirmValidate () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
         this.confirm()
        }
      })
    },
    confirm () {
      if (this.typeList.length === 0) {
        this.$message.warning('请保存至少一个版本信息')
        return false
      }
      let flag = false
      for (let i = 0; i < this.typeList.length; i++) {
        if (!this.typeList[i].versionCode || !this.typeList[i].description) {
          this.$message.warning('必填项不能为空！')
          flag = true
          return
        }
      }
      if (flag) {
        return false
      }
      this.confirmLoading = true
      // this.commitdata.dtoList = this.typeList
      const newArray = this.typeList.map(obj => {
            return {
              ...obj, // 使用展开运算符来保留原对象的属性
              monthStart: this.commitdata.forecastMonthStart, // 增加新的属性
              monthEnd: this.commitdata.forecastMonthEnd
            };
          });
        newScpSopBasicData({ validateFlag: this.inputType === 2 ? "Y" : "N", scpSopBasicDataDTOList: newArray }).then(response => {
        if (response.code === 200) {
          this.$message.success('新增成功')
          // 关闭本组件
          this.visible = false
          // 调用外部刷新列表方法
          this.$emit('handle-success')
          // 刷新表单
          this.reset()
          this.confirmLoading = false
        } else {
          this.$message.error(response.msg)
          this.confirmLoading = false
        }
      }).catch(e => {
        this.confirmLoading = false
      })
    },
    // 表单重置
    reset () {
      this.commitdata = {
        forecastName: '', // 预测名称
        forecastMonthStart: '', // 预测起始月
        forecastMonthEnd: '', // 预测起始月
        forecastMonthTem: [], // 临时时间
        dtoList: [] // 列表数据
      }
      this.typeList = []
    }
  }
}
</script>

<style scoped lang="less">
/deep/.ant-select{
  width: 150px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}.rp-width{
  width: 200px
}.ip-width{
  width: 150px
}
</style>
